import React, { useState, useEffect } from 'react';
import { useNavigate, Outlet, useLocation, Link as RouterLink } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Box, Collapse, List, ListItem, ListItemButton, ListItemText, Drawer, Divider, useMediaQuery, useTheme, IconButton } from '@mui/material';
import Button from '@mui/material/Button';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import { auth } from '../config/firebase';
import logoWhite from '../assets/logo-white.png';

const Dashboard = () => {
    const navigate = useNavigate();
    const [selectedItem, setSelectedItem] = useState('projects');
    const [openDrawer, setOpenDrawer] = useState(false);
    const user = auth.currentUser;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname.split('/');
        const secondSegment = path[2]; // Access the second segment (after /dashboard)

        // Only update if the segment changes
        if (secondSegment && secondSegment !== selectedItem) {
            setSelectedItem(secondSegment);
            localStorage.setItem('selectedItem', secondSegment);
        }
    }, [location, selectedItem]);

    const handleItemClick = (item) => {
        setSelectedItem(item);
        localStorage.setItem('selectedItem', item);
        if (isMobile) {
            setOpenDrawer(false);
        }
        // navigate(`/dashboard/${item}`);
    };

    const handleLogout = () => {
        try {
            auth.signOut();
        } catch (error) {
            console.error('Error signing out:', error);
        };
    };

    // Automatically refresh the page upon logout
    // Debug this one later...
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (user) => {
            console.log("User in Dashboard:", user);
            if (!user) {
                localStorage.removeItem('selectedItem');
                localStorage.removeItem('snackbarMessage');
                localStorage.removeItem('redirectAfterLogin');
                navigate('/');
            }
        });
        return () => unsubscribe();
    }, []);

    return (
        <div>
            <AppBar position="static">
                <Toolbar>
                    {isMobile && (
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={() => setOpenDrawer(true)}
                            edge="start"
                            sx={{ mr: 2 }}
                        >
                            <MenuIcon />
                        </IconButton>
                    )}
                    {!isMobile && (
                        <Box
                            component="img"
                            src={logoWhite}
                            alt="Logo"
                            sx={{ width: 60, height: "auto" }} // responsive sizing
                        />
                    )}
                    <Typography paddingLeft={isMobile ? "0" : "25px"} variant="h6" sx={{ flexGrow: 1 }}>

                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {!isMobile && (
                            <>
                                <AccountCircleIcon />
                                <Typography variant="body1" sx={{ mr: 1 }}>{user.email}</Typography>
                            </>
                        )}
                        <Button color="inherit" onClick={handleLogout} startIcon={<LogoutIcon />} sx={{ ml: 1 }}>
                            Logout
                        </Button>
                    </Box>
                </Toolbar>
            </AppBar>
            <Drawer
                anchor="left"
                open={isMobile && openDrawer}
                onClose={() => setOpenDrawer(false)}
            >
                <List>
                    <ListItem disablePadding>
                        <ListItemButton
                            selected={selectedItem === 'statistics'}
                            onClick={() => handleItemClick('statistics')}
                            id="statistics-button"
                        >
                            <ListItemText primary="Statistics" />
                        </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                        <ListItemButton
                            selected={selectedItem === 'users'}
                            onClick={() => handleItemClick('users')}
                        >
                            <ListItemText primary="Users" />
                        </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                        <ListItemButton
                            selected={selectedItem === 'orders'}
                            onClick={() => handleItemClick('orders')}
                        >
                            <ListItemText primary="Orders" />
                        </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                        <ListItemButton
                            selected={selectedItem === 'plans'}
                            onClick={() => handleItemClick('plans')}
                        >
                            <ListItemText primary="Plans" />
                        </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                        <ListItemButton
                            selected={selectedItem === 'domains'}
                            onClick={() => handleItemClick('domains')}
                        >
                            <ListItemText primary="Domains" />
                        </ListItemButton>
                    </ListItem>
                    {/* <ListItem disablePadding>
                        <ListItemButton
                            selected={selectedItem === 'articles'}
                            onClick={() => handleItemClick('articles')}
                        >
                            <ListItemText primary="Articles" />
                        </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                        <ListItemButton
                            selected={selectedItem === 'jobs'}
                            onClick={() => handleItemClick('jobs')}
                        >
                            <ListItemText primary="Jobs" />
                        </ListItemButton>
                    </ListItem> */}
                    <ListItem disablePadding>
                        <ListItemButton
                            selected={selectedItem === 'configurations '}
                            onClick={() => handleItemClick('configurations ')}
                        >
                            <ListItemText primary="Configurations " />
                        </ListItemButton>
                    </ListItem>
                    <Divider />
                </List>
            </Drawer>
            <Box sx={{ marginTop: '20px', padding: '0 20px', display: '-webkit-box', flexDirection: isMobile ? 'column' : 'row' }}>
                {!isMobile && (
                    <Box sx={{ width: '200px', marginLeft: '20px', marginBottom: isMobile ? '20px' : 0 }}>
                        <List>
                            <ListItem disablePadding>
                                <ListItemButton
                                    component={RouterLink}
                                    to="/dashboard/statistics"
                                    selected={selectedItem === 'statistics'}
                                    onClick={() => handleItemClick('statistics')}
                                    id="statistics-button"
                                >
                                    <ListItemText primary="Statistics" />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton
                                    component={RouterLink}
                                    to="/dashboard/users"
                                    selected={selectedItem === 'users'}
                                    onClick={() => handleItemClick('users')}
                                >
                                    <ListItemText primary="Users" />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton
                                    component={RouterLink}
                                    to="/dashboard/orders"
                                    selected={selectedItem === 'orders'}
                                    onClick={() => handleItemClick('orders')}
                                >
                                    <ListItemText primary="Orders" />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton
                                    component={RouterLink}
                                    to="/dashboard/plans"
                                    selected={selectedItem === 'plans'}
                                    onClick={() => handleItemClick('plans')}
                                >
                                    <ListItemText primary="Plans" />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton
                                    component={RouterLink}
                                    to="/dashboard/domains"
                                    selected={selectedItem === 'domains'}
                                    onClick={() => handleItemClick('domains')}
                                >
                                    <ListItemText primary="Domains" />
                                </ListItemButton>
                            </ListItem>
                            {/* <ListItem disablePadding>
                        <ListItemButton
                            selected={selectedItem === 'articles'}
                            onClick={() => handleItemClick('articles')}
                        >
                            <ListItemText primary="Articles" />
                        </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                        <ListItemButton
                            selected={selectedItem === 'jobs'}
                            onClick={() => handleItemClick('jobs')}
                        >
                            <ListItemText primary="Jobs" />
                        </ListItemButton>
                    </ListItem> */}
                            <ListItem disablePadding>
                                <ListItemButton
                                    component={RouterLink}
                                    to="/dashboard/configurations"
                                    selected={selectedItem === 'configurations '}
                                    onClick={() => handleItemClick('configurations ')}
                                >
                                    <ListItemText primary="Configurations " />
                                </ListItemButton>
                            </ListItem>
                            <Divider />
                        </List>
                    </Box>
                )}
                <Box sx={{ flexGrow: 1, padding: isMobile ? '10px' : '0' }}>
                    <Outlet />
                </Box>
            </Box>
        </div>
    );

};
export default Dashboard;
